module.exports = __webpack_public_path__ + "img/bg_alley.d0da049e.jpg";